import angular from 'angular';
import { CompanyContactsController } from './company-contacts.controller' ;
import { CompanyContactEditOrCreateController } from './company-contact-edit-or-create.controller' ;
import { CompanyContactsService } from './company-contacts.service';


angular
  .module('parameters.company-contacts', [])
  .controller('CompanyContactsController', CompanyContactsController)
  .controller('CompanyContactEditOrCreateController', CompanyContactEditOrCreateController)
  .factory('CompanyContactsFactory', CompanyContactsService.CompanyContactsFactory)
;